import React, { Fragment, useState } from 'react';
import { TextField, Typography, Box, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import MainCard from '../../../../component/cards/MainCard';

const TextFieldInput = ({ data }) => {
    return (
        <MainCard
            title={data.questionNumber ? `Questão ${data.questionNumber}` : null}
            sx={{ mb: 2 }}
        >
            <Box sx={{ p: 3 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <Typography variant="body1" sx={{ fontSize: '18px', mb: 2 }}>
                            {data.value}
                        </Typography>
                        <TextField
                            variant="outlined"
                            fullWidth
                            multiline
                            rows={4}
                            placeholder="Campo de resposta longa"
                            defaultValue={data.answer || ''}
                            disabled
                        />
                    </Grid>
                </Grid>
            </Box>
        </MainCard>
    );
};

TextFieldInput.propTypes = {
    data: PropTypes.object,
    onInputChange: PropTypes.func.isRequired
};

export default TextFieldInput;
